import { camelCase } from "lodash-es"

const getObjectRow  =({title='',rightIconDataAid="right"}) => ({
    rowDataAid: camelCase(title),
    title: {
        text:title,
        dataAid: 'title'
    },
    rightIconDataAid: rightIconDataAid
})

const MISCELLANEOUS = {
    pageDataAid: "Settings",
    pageTitle: {
        text: "Settings",
        dataAid: 'settings'
    }
}

const CONTENT = {
   securityRow: {
        ...getObjectRow({title:"Security"})
   },
    orderPreferenceRow: {
       ...getObjectRow({title:"Order preferences"})
    },
    chartPreferenceRow: {
      ...getObjectRow({title:"Chart preferences"})
    },
    whatsAppNotificationRow: {
       ...getObjectRow({title:"WhatsApp notifications"}),
        toggleButtonDataAid: "whatsAppPref",
        toggleSuccessToast: {
            text: (enabled) => `WhatsApp updates ${enabled ? 'enabled' : 'disabled'}`
        }
    },
    emailSubscriptionRow: {
       ...getObjectRow({title:"Email subscriptions"})
    },
    logoutRow: {
       ...getObjectRow({title:"Log out",rightIconDataAid:"logout"})
    }
}

const SETTINGS = {
    ...MISCELLANEOUS,
    CONTENT
}

export default SETTINGS
